<div class="d-flex flex-column vh-100">
  <static-hdr></static-hdr>

  <section class="container flex-grow-1">
    <div class="card card-custom h-100">
      <div class="card-body">

        <h1 class="font-weight-bold text-primary mb-8 mt-4">الأسئلة الشائعة</h1>
        <div class="bgBoxLight">
            <p-accordion class="flex-grow-1" styleClass="faq py-10">
                <p-accordionTab *ngFor="let item of faqcategories" header="{{item.faqCategory.categoryName}}">
                    <faq-item [categoryId]="item.faqCategory.id"></faq-item>
                </p-accordionTab>
            </p-accordion>
          <!-- <p-accordion class="flex-grow-1" styleClass="faq py-10">
            <p-accordionTab header="ما هي الفئة المستهدفة لاستخدام منصة برنامج كفاءة الطاقة في الجهات الحكومية؟ ">
               رؤساء وأعضاء فرق كفاءة الطاقة في الجهات الحكومية.
            </p-accordionTab>
            <p-accordionTab header="ماهي طريقة التسجيل في المنصة لرئيس فريق كفاءة الطاقة في الجهة الحكومية؟">
               سيتم إرسال رابط التسجيل على البريد الالكتروني ورقم الجوال المذكور في خطاب ترشيح رئيس الفريق.
            </p-accordionTab>
            <p-accordionTab header="هل يسمح لأي موظف حكومي التسجيل في المنصة؟">
               لا ، يسمح بالتسجيل فقط لرئيس وأعضاء فريق كفاءة الطاقة في الجهة.
            </p-accordionTab>
            <p-accordionTab header="تم ترشيحي لرئاسة فريق كفاءة الطاقة في جهتي ولم يصلني رابط التسجيل، ماذا أفعل؟">
               	بإمكانك التواصل مع المركز السعودي لكفاءة الطاقة للتنسيق بهذا الشأن.
            </p-accordionTab>
            <p-accordionTab header="كيف يتم ترشيح منسوبي الجهات الحكومية لحضور الدورات التدريبية؟">
               يتم ذلك عن طريق رئيس فريق كفاءة الطاقة في الجهة.
            </p-accordionTab>
            <p-accordionTab header="أرغب في أن أكون رئيس فريق كفاءة الطاقة في جهتي ما هو الإجراء المتبع؟">
             يتم ذلك عن طريق إرسال خطاب ترشيح من الجهة إلى المركز السعودي لكفاءة الطاقة.
            </p-accordionTab>
            <p-accordionTab header="الاسئلة العامة">
                <p-accordion class="flex-grow-1" styleClass="faq py-10">
                    <p-accordionTab header="أرغب في أن أكون رئيس فريق كفاءة الطاقة في جهتي ما هو الإجراء المتبع؟">
                        يتم ذلك عن طريق إرسال خطاب ترشيح من الجهة إلى المركز السعودي لكفاءة الطاقة.
                       </p-accordionTab>
                </p-accordion>
            </p-accordionTab>
          </p-accordion> -->
        </div>
      </div>
      <div class="card-footer d-flex justify-content-between">
        <button type="button" class="btn btn-outline-light btn-lg px-8" [routerLink]="['/home']">
          عودة
        </button>
      </div>

    </div>
  </section>

  <static-ftr></static-ftr>
</div>
